// extracted by mini-css-extract-plugin
export default {"subtitle":"subtitle__Ehbzq9NI","sourceTypeSummaryWrapper":"sourceTypeSummaryWrapper__n2Euam4z","helpLink":"helpLink__RGQjcjsz","icon":"icon__me7iSJDD","footer":"footer__mPYFvV3Z"};